import { MessageBar, MessageBarType, Stack, Text } from '@fluentui/react';
import { IPendingMergeValidationError } from './CompareContext.helpers';

interface IPendingMergeWarningProps {
    error: IPendingMergeValidationError | null;
}

const PendingMergeWarning: React.FC<IPendingMergeWarningProps> = (props) => {
    if (!props.error)
        return null;

    return (
        <MessageBar
            messageBarType={MessageBarType.error}
            isMultiline={true}
            styles={{ root: { margin: '10px' } }}
        >
            <Stack tokens={{ childrenGap: 8 }}>
                <Text variant='mediumPlus' styles={{ root: { fontWeight: 600 } }}>
                    {props.error.summary}
                </Text>

                <Stack horizontal wrap tokens={{ childrenGap: 6 }}>
                    {props.error.levelItems.map((levelItem) => (
                        <Text
                            key={levelItem}
                            variant='small'
                            styles={{
                                root: {
                                    backgroundColor: '#f3f2f1',
                                    border: '1px solid #edebe9',
                                    borderRadius: 12,
                                    padding: '2px 8px',
                                }
                            }}
                        >
                            {levelItem}
                        </Text>
                    ))}
                </Stack>

                {props.error.samples.length > 0 && (
                    <Stack tokens={{ childrenGap: 4 }}>
                        <Text variant='small' styles={{ root: { fontWeight: 600 } }}>
                            Examples
                        </Text>
                        {props.error.samples.map((sample, index) => (
                            <Text key={`${sample}-${index}`} variant='small'>
                                - {sample}
                            </Text>
                        ))}
                    </Stack>
                )}

                <Text variant='small'>
                    Resolve pending selections, then click Preview again.
                </Text>
            </Stack>
        </MessageBar>
    );
};

export default PendingMergeWarning;
